<template>
  <component :is="label || icon ? 'label' : 'div'" class="flex items-center gap-1">
    <span v-if="icon || label" class="flex items-center gap-1 text-sm">
      <SMIcon v-if="icon" :icon="icon" />
      <span v-if="label">{{ label }}</span>
    </span>
    <input
      ref="inputRef"
      v-model="val"
      :placeholder="placeholder"
      :type="type"
      :disabled="disabled"
      @blur="emit('blur', $event)"
    />
  </component>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import SMIcon from './SMIcon.vue';
import { computed } from 'vue';

const props = defineProps({
  modelValue: {
    type: [String, Number],
  },
  label: {
    type: String,
    required: false,
  },
  placeholder: {
    type: String,
    required: false,
  },
  type: {
    type: String,
    required: false,
  },
  icon: {
    type: String,
    required: false,
  },
  disabled: {
    type: Boolean,
  },
});

const emit = defineEmits(['change', 'update:modelValue', 'blur']);

const val = computed({
  get: () => props.modelValue,
  set: (value) => {
    emit('update:modelValue', value);
    emit('change', value);
  },
});

const inputRef = ref<HTMLInputElement>();

defineExpose({
  focus: () => inputRef.value?.focus(),
  reportValidity: () => inputRef.value?.reportValidity(),
  input: inputRef,
});
</script>

<style scoped lang="scss">
input {
  all: unset;
  -webkit-user-select: auto !important;
  user-select: auto !important;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  padding: 4px 8px;
  width: 100%;
  box-sizing: border-box;
  font-size: 14px;
  line-height: 1.5;
  color: rgba(0, 0, 0, 0.65);
  background-color: #fff;
  background-image: none;
  transition: all 0.3s;
  cursor: text;
  &:focus {
    border-color: #40a9ff;
    outline: 0;
    box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
  }

  &::placeholder {
    color: #d9d9d9;
  }

  &:disabled {
    background-color: #f5f5f5;
    cursor: not-allowed;
    color: rgba(0, 0, 0, 0.25);
  }

  &:read-only {
    background-color: #fafafa;
    border-color: #d9d9d9;
    cursor: not-allowed;
  }
}
</style>
